import React, { Component } from "react";


import MyBody from './mybody';

import OilPremixCalculator from '../components/oilpremixcalculator';

class MyPage extends Component {

    render() {
        return (<OilPremixCalculator/>)
    }

}

export default MyPage;